import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
`

export const Grid = styled('table')`
  border-collapse: collapse;
  width: 100%;
  font-size: 14px;

  th,
  td {
    padding: 6px 8px;
    text-align: center;
    border-bottom: 1px solid ${colors.gray200};
  }

  th:first-child,
  td:first-child {
    text-align: left;
    font-weight: 600;
  }

  thead th {
    text-transform: capitalize;
    color: ${colors.gray300};
    font-weight: 600;
  }

  .MuiCheckbox-root {
    padding: 4px;
  }
`

export const Hint = styled('span')`
  font-size: 12px;
  margin-top: 8px;
  color: ${colors.gray300};
`
